export const isAssociationValueSet = (value) =>
  value !== null && value !== undefined && value !== "";

export const resolveEffectiveOrgId = (authUser, orgId) => {
  if (authUser()?.role === 1) {
    return orgId === "" || orgId == null ? null : Number(orgId);
  }
  if (authUser()?.user?.org_id != null && authUser()?.user?.org_id !== "") {
    return Number(authUser().user.org_id);
  }
  if (orgId != null && orgId !== "") {
    return Number(orgId);
  }
  return null;
};

export const validateDeviceAssociations = (
  values,
  { requireAssociation = true } = {}
) => {
  const errors = {};
  const hasPatient = isAssociationValueSet(values.patient_id);
  const hasKit = isAssociationValueSet(values.kit_id);
  const hasOrg = isAssociationValueSet(values.org_id);

  if (hasPatient && hasKit) {
    errors.association =
      "Il dispositivo può essere associato a un paziente oppure a un kit, non entrambi";
  } else if (requireAssociation && !hasOrg && !hasPatient && !hasKit) {
    errors.association =
      "Associa il dispositivo a un'organizzazione, a un paziente o a un kit";
  }

  return errors;
};

export const validateDeviceForm = (
  values,
  { requireSerialNumber = true, requireAssociation = true } = {}
) => {
  const errors = validateDeviceAssociations(values, { requireAssociation });

  if (requireSerialNumber) {
    const serial = (values.serial_number ?? "").toString().trim();
    if (!serial) {
      errors.serial_number = "Numero seriale obbligatorio";
    }
  }

  const valid = Object.keys(errors).length === 0;
  const message = errors.serial_number || errors.association || null;

  return { valid, errors, message };
};

export const buildDevicePayload = (values, authUser) => {
  const hasPatient = isAssociationValueSet(values.patient_id);
  const hasKit = isAssociationValueSet(values.kit_id);
  const role = authUser()?.role;

  if (role === 2 || role === 3) {
    return {
      patient_id: hasPatient ? Number(values.patient_id) : null,
      kit_id: hasKit ? Number(values.kit_id) : null,
      is_online: values.is_online,
      is_installed: values.is_installed,
    };
  }

  const orgId =
    hasPatient || hasKit
      ? null
      : role === 1
        ? isAssociationValueSet(values.org_id)
          ? Number(values.org_id)
          : null
        : authUser()?.user?.org_id ?? null;

  return {
    ...values,
    serial_number:
      typeof values.serial_number === "string"
        ? values.serial_number.trim()
        : values.serial_number,
    patient_id: hasPatient ? Number(values.patient_id) : null,
    kit_id: hasKit ? Number(values.kit_id) : null,
    org_id: orgId,
  };
};
